import { UNLICENSED } from '@jira/platform__application-editions/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';

/**
 * Determines whether the current tenant/user is eligible to see the Help
 * Center Management L1 sidebar entry, based on license and permissions.
 *
 * Rules (both must be true for this hook to return `true`):
 *   1. Tenant has a JSM license — `appEditions.serviceDesk !== UNLICENSED`.
 *   2. Current user is a Jira admin
 */
export const useShowHelpCenterManagement = (): boolean => {
	const { serviceDesk } = useAppEditions();
	const isAdmin = useIsAdmin();

	if (serviceDesk === UNLICENSED) {
		return false;
	}

	return isAdmin;
};
